// https://inopinatus.org/2019/09/14/webpacker-jquery-and-jquery-plugins/
// all the jquery and plugins
require('jquery-ui/ui/widget')
require('jquery-ui/ui/position')
require('jquery-ui/ui/widgets/mouse')
require('jquery-ui/ui/widgets/draggable')
require('jquery-ui/ui/widgets/droppable')
require('jquery-ui/ui/widgets/autocomplete')
require('jquery-ui/ui/widgets/menu')
require('jquery-ui/ui/widgets/slider')

require('jquery-ui-touch-punch-0.2.3')
require('jquery.nestable')
require('jquery.scrollTo')
require('jquery.timeago')

require('mathquill')
require('knowl')
require('webwork_scaffold')
require('switch-checkbox')
